exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timer{font-size:15px;color:#020202;text-align:center;margin-top:50px}.timer .day,.timer .hour,.timer .min,.timer .sec{font-size:30px;display:inline-block;font-weight:500;text-align:center;margin:0 5px}.timer .day .format,.timer .hour .format,.timer .min .format,.timer .sec .format{font-weight:300;font-size:14px;opacity:.8;width:60px}.timer .number{background:rgba(51,51,51,.53);padding:0 5px;border-radius:5px;display:inline-block;width:60px;text-align:center}.timer .message{font-size:14px;font-weight:400;margin-top:5px}.timer .status-tag{width:270px;margin:10px auto;padding:8px 0;font-weight:500;color:#000;text-align:center;border-radius:15px}.timer .status-tag.upcoming{background-color:#90ee90}.timer .status-tag.running{background-color:gold}.timer .status-tag.expired{background-color:silver}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-24688389","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Countdown.vue
// module id = 29
// module chunks = 0